import { render, staticRenderFns } from "./LocationSessions.vue?vue&type=template&id=68d79f40&"
import script from "./LocationSessions.vue?vue&type=script&lang=js&"
export * from "./LocationSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports